export const MANAGE_MONEY_TABS = {
  OVERVIEW: 'OVERVIEW',
  PAY_BILLS: 'PAY_BILLS',
} as const;
